import { type } from 'arktype'

/**
 * Parses a Dutch KvK (Kamer van Koophandel) number.
 *
 * @see https://developers.kvk.nl/documentation/zoeken-api
 */
export function parseKvkValue(input: string): string | null {
  const normalizedInput = input.replace(/[\s.-]/g, '')
  if (kvkRegex.test(normalizedInput)) {
    return normalizedInput
  }
  return null
}

export const kvkValueType = type('string').narrow((s) => parseKvkValue(s) !== null)

export const kvkRegex = /^[0-9]{8}$/
